import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { authInterceptor } from './globalInterceptors/auth.interceptor';
import { formDataInterceptor } from './globalInterceptors/formdata.interceptor';
import { schoolCodeInterceptor } from './globalInterceptors/school-code.interceptor';
import { ErrorHandlerService } from './globalServices/errorHandler.service';
import { provideStore } from '@ngrx/store';
import { credentialsInterceptor } from './globalInterceptors/credentials.interceptor';
import { NavigationService } from './globalServices/error-screen-navigation.service';
import { PermissionService } from './globalServices/permission.service';
import { FeatureFlagService } from './globalServices/feature-flag.service';
import { ERROR_SCREEN_NAVIGATION } from '@invessio/ui';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        formDataInterceptor,
        schoolCodeInterceptor,
        credentialsInterceptor,
      ])
    ),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideStore({
      // TODO: Add reducers here
    }),
    {
      provide: ERROR_SCREEN_NAVIGATION,
      useClass: NavigationService,
    },
    provideAppInitializer(() => {
      const permissionService = inject(PermissionService);
      return permissionService.fetchAuth();
    }),
    provideAppInitializer(() => {
      const featureFlagService = inject(FeatureFlagService);
      return featureFlagService.getFlags();
    })
  ]
};
